import { defaultFill } from '../utils/constants';
var muiChevronLeftGlyph = {
    paths: [
        {
            path: 'M-1.29289322,3.79489797 C-1.68341751,3.40437368 -2.31658249,3.40437368 -2.70710678,3.79489797 C-3.09763107,4.18542227 -3.09763107,4.81858724 -2.70710678,5.20911154 L4.29289322,12.2091115 C4.68341751,12.5996358 5.31658249,12.5996358 5.70710678,12.2091115 L12.7071068,5.20911154 C13.0976311,4.81858724 13.0976311,4.18542227 12.7071068,3.79489797 C12.3165825,3.40437368 11.6834175,3.40437368 11.2928932,3.79489797 L5,10.0877912 L-1.29289322,3.79489797 Z',
            fill: defaultFill,
        },
    ],
    title: 'Chevron Left',
    width: 10,
    height: 16,
    rotate: 90,
};
var muiChevronLeft = {
    base: muiChevronLeftGlyph,
};
export { muiChevronLeft };
//# sourceMappingURL=chevronLeft.js.map